import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as GroupListActions from './Grouplist.action';
import { NSAdminbuysellRuleserviceService } from '../../Clients/NS/Services/NSAdminbuysellRuleservice.service';

@Injectable()
export class GroupListEffects {
  constructor(
    private actions$: Actions,
    private buysellRuleservice: NSAdminbuysellRuleserviceService
  ) {}

  loadGroupList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GroupListActions.loadGroupList),
      mergeMap(() =>
        this.buysellRuleservice.GetGrouplist().pipe(
          map((groups) => GroupListActions.loadGroupListSuccess({ groups })),
          catchError((error) =>
            of(GroupListActions.loadGroupListFailure({ error }))
          )
        )
      )
    )
  );
}
